<template>
  <cc-container>
    <cc-header-nav>
      <div class="search-box" slot="center">
        <input
          v-model="form.keyword"
          type="text"
          placeholder="请输入通用名/商品名/厂家"
          class="input-search"
          style="padding-left: 0.65rem;"
          @keyup.13="search(form.keyword)"
          @keyup="keyUp()"
        />
        <cc-svg-icon
          size=".16rem"
          class-name="cancel-icon-main"
          icon-class="cancel"
          v-if="cancelIconShow"
          @click="form.keyword=''"
        ></cc-svg-icon>
        <div class="sel-box" @click="showcode=!showcode">
          <span class="mr5 ml10">{{searchTypeTxt}}</span>
          <cc-svg-icon
            style="vertical-align: middle;"
            size=".10rem"
            class-name="class-down-icon mr5"
            :icon-class="showcode?'class-arrow':'class-down'"
          ></cc-svg-icon>
          <b></b>
          <ul class="dn" v-if="showcode">
            <span class="tle"></span>
            <li @click="changeCode(1)" class="on">综合</li>
            <li @click="changeCode(2)" data-options="2">编码</li>
          </ul>
        </div>
      </div>
      <span slot="right" class="f13" @click="search(form.keyword)">搜索</span>
    </cc-header-nav>
    <cc-main class="main">
      <div v-if="realTimeShow">
        <div class="hot-title">热搜词</div>
        <div class="hot-tag">
          <div>
            <div
              @click="search(item,1)"
              v-for="(item,index) in hotData.tags_top"
              :key="index"
              class="searchtxt"
            >{{item.name}}</div>
          </div>
          <div :class="hotTexDownShow?'ellipsis1':''" :style="{'height':hotTexDownShow?'44px':'auto'}">
            <div
              @click="search(item)"
              class="nbt searchtxt"
              v-for="(item,index) in hotData.keyword"
              :key="index"
            >{{item}}</div>
            <span class="nbt-down">
              <cc-svg-icon v-if="hotTexDownShow" @click="hotTexDownShow=false" size="0.30rem" icon-class="down-arrow" class-name="down-arrow"></cc-svg-icon>
            </span>
          </div>
        </div>
        <div class="hot-title">
          搜索历史
          <cc-svg-icon v-if="historyData.length" @click="del" class="delete-icon" size="0.15rem" icon-class="delete" />
        </div>
        <!-- 最多20条数据 -->
        <div
          class="history"
          v-if="historyData.length"
          :class="hisDownShow?'ellipsis':''"
        >
          <div
            class="nbt searchtxt"
            @click="search(item)"
            v-for="(item,index) in historyData"
            :key="index"
          >{{item}}</div>
          <span class="nbt-down">
            <cc-svg-icon
              v-if="hisDownShow"
              @click="hisDownShow=false"
              icon-class="down-arrow"
              size="0.30rem"
              class-name="down-arrow"
            ></cc-svg-icon>
          </span>
        </div>
      </div>
      <!-- 搜索实时结果-->
      <div class="realTimebox" v-else>
        <p
          v-for="(item,index) in nowTimeData"
          :key="index"
          @click="search(decodeURIComponent(item.general_name))"
        >{{decodeURIComponent(item.general_name)}}</p>
      </div>
    </cc-main>
  </cc-container>
</template>
<script>
import { productSearch, jonSearch } from '@/fetch/categorylist/index.js'
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
Vue.use(Dialog)
  .use(Toast)
export default {
  data () {
    return {
      hotTexDownShow: true,
      searchval: '',
      searchTypeTxt: '综合',
      // 搜索实时结果显示开关
      realTimeShow: true,
      showcode: false,
      hotData: '',
      cancelIconShow: false,
      nowTimeData: '',
      form: {
        keyword: '',
        types: 1,
        tags: ''
      },
      historyData: [],
      hisDownShow: true
    }
  },
  watch: {
    form: {
      // 深度监听
      deep: true,
      handler (val) {
        this.cancelIconShow = !!val.keyword.length
      }
    }
  },
  mounted () {
    this.loadData()
    this.form.keyword = this.$route.query.keyword
      ? this.$route.query.keyword
      : ''
    this.form.types = this.$route.query.types ? this.$route.query.types : ''
    this.searchTypeTxt = this.$route.query.types === 2 ? '编码' : '综合'
    if (localStorage.getItem('historyData')) {
      let str = localStorage.getItem('historyData')
      this.historyData = str.split(',')
      this.historyData = this.historyData.filter(item => {
        return item !== ''
      })
    }
  },
  methods: {
    async loadData () {
      let { data } = await productSearch()
      this.hotData = data
    },
    changeCode (index) {
      this.searchTypeTxt = index === 1 ? '综合' : '编码'
      this.form.types = index
    },
    /**
     *  搜索跳转
     */
    search (item, index) {
      if (index) {
        this.form.tags = item.id
      } else {
        this.form.keyword = item
      }
      // 暂时用这个方法来判断是搜索页进入快捷采购页的
      sessionStorage.setItem('isSearch', 1)
      this.$router.push({
        path: '/categorylist',
        query: this.form
      })
      // 要处理下重复的数据 并把重复的数据排前
      this.historyData = this.historyData.filter((item, index) => {
        return item !== this.form.keyword && index < 19 && item !== ''
      })
      this.historyData.unshift(this.form.keyword)
    },
    async keyUp () {
      if (this.form.keyword) {
        this.realTimeShow = false
      } else {
        this.realTimeShow = true
      }
      var params = { keyword: this.form.keyword, type: this.form.types }
      let { data } = await jonSearch(params)
      this.nowTimeData = data.search_data
    },
    del () {
      Dialog.confirm({
        message: '确定要删除全部历史记录吗？'
      })
        .then(() => {
          localStorage.removeItem('historyData')
          this.historyData = []
        })
        .catch(() => {
        })
    }
  },
  destroyed () {
    localStorage.setItem('historyData', this.historyData)
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/index.scss";
.search-box {
  color: #333333;
}
.cancel-icon-main {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 5px;
}
.main {
  background: #fff;
  padding: 0 10px;
  box-sizing: border-box;
  .hot-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-weight: bold;
    @include sc(14px, #333333);
    position: relative;
    .delete-icon {
      position: absolute;
      right: 0;
      color: #999999;
    }
  }
  .hot-tag,
  .history {
    flex-wrap: wrap;
    position: relative;
    padding-right: 30px;
      .searchtxt{
      display: inline-block;
      font-size: 12px;
      padding: 0 17.5px;
      height: 34px;
      border-radius: 17px;
      margin: 5px 10px 5px 0;
      line-height: 34px;
    }
    .nbt {
      color: #777777;
      background: #f7f7f7;
    }
    .nbt-down {
      position: absolute;
      right: -10px;
      top: 40px;
      padding: 6.5px;
      margin: 0;
    }
    div:nth-child(1) {
      div {
        color: var(--APP_theme_color);
        background: var(--APP_theme_color_colorOpacity1);
      }
    }
  }
  .realTimebox {
    p {
      height: 44.5px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
    }
  }
}
.ellipsis{
   overflow : hidden;
    text-overflow: clip;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.ellipsis1{
    overflow : hidden;
}
.sel-box {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  left: -3px;
  height: 28px;
  width: 63.5px;
  line-height: 28px;
  @include sc(12px, #a9a9a9);
  b {
    width: 1px;
    height: 20px;
    background-color: #ccc;
    position: absolute;
    margin-top: 5px;
    margin-left: 3px;
  }
  ul {
    position: absolute;
    background: #fff;
    margin-top: 11px;
    box-shadow: 3px 3px 3px #ccc;
    display: block;
    height: 34px;
    width: 93px;
    li {
      width: 46px;
      height: 34px;
      float: left;
      line-height: 34px;
      text-align: center;
      border-right: 1px solid #ccc;
    }
    li:last-child {
      border-right: 0;
    }
  }
  span.tle {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    position: absolute;
    margin-top: -10px;
    margin-left: 10px;
    top: 1px;
    left: 5px;
  }
}
</style>
